import axios from 'axios'

interface SuccessResponse {
  success: true,
  data: Storage[]
}
interface ErrorResponse {
  success: false
  error: string
}
type Response = SuccessResponse|ErrorResponse
class BootboxService {
  async checkinBootbox (bootbox_id: string, boot_serial: string, immobilization_case_id: string): Promise<Response> {
    try {
      const response: any = await axios.post('/driver-api/bootbox-checkin', {
        bootbox_id,
        boot_serial,
        immobilization_case_id
      })

      return { success: true, data: response.data }
    } catch (e: any) {
      return { success: false, error: e.response.data.error }
    }
  }

  async getBootbox (bootbox_id: string): Promise<Response> {
    try {
      const response:any = await axios.get(`/driver-api/bootbox/${bootbox_id}`)
      return { success: true, data: response.data }
    } catch (e: any) {
      if (e.response.status === 404) {
        return { success: false, error: 'Bootbox not found' }
      } else {
        return { success: false, error: `Unknown response code ${e.response.status}` }
      }
    }
  }
}

export default BootboxService
